var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPrivacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "6158f4f00d5930b4a4f1082e_icon-privacy.svg",
    clipPath: "url(#clip0_13_476)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval-Copy-10",
    d: "M23 45.9193C35.4264 45.9193 45.5 35.8457 45.5 23.4193C45.5 10.9929 35.4264 0.919312 23 0.919312C10.5736 0.919312 0.5 10.9929 0.5 23.4193C0.5 35.8457 10.5736 45.9193 23 45.9193Z",
    fill: "#2350F1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2115 14.7655C26.5391 14.7655 27.6154 15.8324 27.6154 17.1484V20.5347H28.7692C29.7251 20.5347 30.5 21.3096 30.5 22.2655V29.7655C30.5 30.7214 29.7251 31.4963 28.7692 31.4963H17.8077C16.8518 31.4963 16.0769 30.7214 16.0769 29.7655V22.2655C16.0769 21.3096 16.8518 20.5347 17.8077 20.5347H18.9615V17.1484C18.9615 15.8324 20.0378 14.7655 21.3654 14.7655H25.2115ZM25.2115 16.1953H21.3654C20.8585 16.1953 20.4432 16.5841 20.4065 17.0773L20.4038 17.1484V20.5347H26.1731V17.1484C26.1731 16.6459 25.7808 16.2343 25.2833 16.1979L25.2115 16.1953Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_476"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white",
    transform: "translate(0.5 0.919312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrivacy);
export default __webpack_public_path__ + "static/media/icon-privacy.a1ba94b0c4398039129f0f9109372ba6.svg";
export { ForwardRef as ReactComponent };